import { appConfig, pad } from "../../../utils";

import { getRiskColor } from "../Forms/actions.js";
import { tooltip as overallRiskTooltip } from "./overallRiskTooltip.js";

const likelihoods = [{
    "label": "0 - Undecided",
    "id": "0 - Undecided"
}, {
    "label": "1 - Extremely Improbable",
    "id": "1 - Extremely Improbable"
}, {
    "label": "2 - Improbable",
    "id": "2 - Improbable"
}, {
    "label": "3 - Remote",
    "id": "3 - Remote"
}, {
    "label": "4 - Occasional",
    "id": "4 - Occasional"
}, {
    "label": "5 - Frequent",
    "id": "5 - Frequent"
}];

const consequences = [{
    "label": "0 - Undecided",
    "id": "0 - Undecided"
}, {
    "label": "A - Negligible",
    "id": "A - Negligible"
}, {
    "label": "B - Minor",
    "id": "B - Minor"
}, {
    "label": "C - Major",
    "id": "C - Major"
}, {
    "label": "D - Hazardous",
    "id": "D - Hazardous"
}, {
    "label": "E - Catastrophic",
    "id": "E - Catastrophic"
}];

export const addSafetyMonitoringReport = ({ form, store, router, db }) => {
    const nextRevision = 1;
    const nextRevisionID = `--${pad(nextRevision, 2)}`;

    form.setConfig({
        "title": "Add Safety Monitoring Report",
        "type": "push",
        "location": "SafetyManagement/SafetyMonitoringReports",
        "fields": [{
            "label": "Number",
            "type": "value",
            value() {
                return `${appConfig.docPrefix}SMR-${pad(store.state.counts.safemon.count)}`
            }
        }, {
            "label": "Title",
            "name": "Title",
            "type": "text",
        }, {
            "label": "File",
            "name": "File",
            "type": "file",
            "required": true
        }],
        async preSubmitHook({ db }) {
            const number = await db.utils.allocateCount("counts/safemon/count");
            return {
                "Number": `${appConfig.docPrefix}SMR-${pad(number)}`,
                "Likelihood": "0 - Undecided",
                "Consequence": "0 - Undecided"
            }
        },
        async postSubmitHook({ files, typeRef }) {
            for (const file of files) {
                await db.upload(`Database/SafetyMonitoringReports/${typeRef.key}/Revisions/${nextRevisionID}`, file[0]);
            }

            await db.update(`SafetyManagement/SafetyMonitoringReports/${typeRef.key}/`, {
                "Revision": nextRevision,
                "RevisionID": nextRevisionID,
                [`Revisions/${nextRevisionID}`]: {
                    "Revision": nextRevision,
                    "By": store.state.user.Basic.name,
                    "Date": new Date().toISOString(),
                    "ID": nextRevisionID,
                    "File": files[0][0].name,
                }
            });

            return;
        }
    });
    form.toggle();
};

export const reviseSafetyMonitoringReport = ({ form, pageItem, store, db }) => {
    const nextRevision = parseInt(pageItem.Revision) + 1;
    const nextRevisionID = `--${pad(nextRevision, 2)}`;

    form.setValues(pageItem);
    form.setConfig({
        "title": "Revise Safety Monitoring Report",
        "type": "update",
        "location": `SafetyManagement/SafetyMonitoringReports/${pageItem.ID}`,
        "fields": [{
            "label": "Next Revision",
            "type": "value",
            value() {
                return nextRevision;
            }
        }, {
            "label": "File",
            "name": "File",
            "type": "file",
            "required": true
        }],
        async postSubmitHook({ files }) {
            for (const file of files) {
                await db.upload(`Database/SafetyMonitoringReports/${pageItem.ID}/Revisions/${nextRevisionID}`, file[0]);
            }

            await db.update(`SafetyManagement/SafetyMonitoringReports/${pageItem.ID}/`, {
                "Revision": nextRevision,
                "RevisionID": nextRevisionID,
                [`Revisions/${nextRevisionID}`]: {
                    "Revision": nextRevision,
                    "Date": new Date().toISOString(),
                    "By": store.state.user.Basic.name,
                    "ID": nextRevisionID,
                    "File": files[0][0].name,
                }
            });

            return;
        }
    });
    form.toggle();
};

export const editRiskAssessment = ({ form, pageItem, store, db }) => {
    form.setValues(pageItem);
    form.setConfig({
        "title": "Edit Risk Assessment",
        "type": "update",
        "location": `SafetyManagement/SafetyMonitoringReports/${pageItem.ID}`,
        "fields": [{
            "label": "Likelihood",
            "tooltip": "Select the likelihood of this event happening again.",
            "name": "Likelihood",
            "type": "dropdown",
            "required": true,
            "dropdownData": likelihoods
        }, {
            "label": "Consequence",
            "tooltip": "Select the best description of the consequences if this event were to occur.",
            "name": "Consequence",
            "type": "dropdown",
            "required": true,
            "dropdownData": consequences
        }, {
            "label": "Overall Risk",
            "type": "value",
            "tooltip": overallRiskTooltip,
            value: ({ liveInputData }) => getRiskColor(liveInputData?.Likelihood?.split(" - ")[0], liveInputData?.Consequence?.split(" - ")[0])
        }],
        preSubmitHook({ liveInputData }) {
            return {
                "ConsequenceValue": liveInputData.Consequence.split(" - ")[0],
                "LikelihoodValue": parseInt(liveInputData.Likelihood.split(" - ")[0])
            }
        }
    });
    form.getDropdownData();
    form.toggle();
};
